import {useInfiniteQuery} from '@tanstack/react-query';
import {directoryService} from '../services/directory';
import type {FileQueryResponse} from '../types/directory';

export function useFileList(
  parentId?: number | string,
  pageSize?: number,
  accessPath?: string
) {
  return useInfiniteQuery<FileQueryResponse>({
    queryKey: ['file-list', parentId, accessPath],

    queryFn: ({pageParam = 1}) => directoryService.getDirectory({
      parent_id: Number(parentId),
      page: pageParam,
      page_size: pageSize,
      access_path: accessPath
    }),

    enabled: parentId != null,

    getNextPageParam: (lastPage: FileQueryResponse) => {
      const {page, total_pages} = lastPage.pagination;
      return page < total_pages ? page + 1 : undefined;
    },

    staleTime: 5 * 1000,
    cacheTime: 5 * 60 * 1000,

    refetchInterval: (data) => {
      const hasProcessingFile = data?.pages?.some(page =>
        page.items?.some((item: any) =>
          item.type === 'file' && item.status !== 1
        )
      );
      return hasProcessingFile ? 30 * 1000 : false;
    },
    refetchIntervalInBackground: false
  });
}